<template>
  <a-form
    :form="form"
    ref="form"
    label-position="left"
    label-width="0px"
    @submit.prevent="onSubmit"
    class="form-container"
    layout="vertical"
  >
    <h2 class="text-center">Utwórz hasło</h2>
    <a-form-item
      label="Hasło"
      required
      :help="errors.new_password"
      :validate-status="errors.new_password ? 'error' : ''"
    >
      <a-input
        type="password"
        v-model="form.new_password"
        auto-complete="off"
        required
        placeholder="hasło"
      >
      </a-input>
    </a-form-item>
    <a-button
      type="primary"
      html-type="submit"
      class="fluid"
      size="large"
      :loading="loading"
    >
      <span>Zapisz</span>
    </a-button>
  </a-form>
</template>
<script>
import { Auth } from '@/api'

export default {
  data() {
    return {
      loading: false,
      form: {},
      errors: {}
    }
  },
  created() {
    window.localStorage.removeItem('token')
  },
  methods: {
    redirectOnSuccess() {
      this.$router.push({
        name: 'Login'
      })
    },
    onSubmit() {
      this.loading = true
      let payload = {
        new_password: this.form.new_password,
        token: this.$route.params.token,
        uid: this.$route.params.uid
      }
      Auth.resetPassword(payload)
        .then(() => {
          this.redirectOnSuccess()
        })
        .catch(error => {
          this.errors = error.response.data
          let message = 'Wystąpił błąd.'

          if (error.response.data.non_field_errors) {
            message = `${message} ${error.response.data.non_field_errors}`
          }

          this.$message.error(message)
        })
      this.loading = false
    }
  }
}
</script>
